module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"parallelSuborder":"Create Parallel Suborder"},"no":{"parallelSuborder":"Lag parallell strekning"}}')
  delete Component.options._Ctor
}
